import { Form, FormItemProps, Select } from 'antd';
import React, { ReactElement } from 'react';
import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { Airline } from 'types';

const { Option } = Select;

interface Props extends FormItemProps<string> {
  placeholder?: string;
  onChange?: (e: number) => void;
}

export function FieldAirline(props: Props): ReactElement | null {
  if (!LeashContent?.airlines) return null;
  const { name, label, placeholder, required = true, onChange = () => 0 } = props;

  return (
    <Form.Item
      name={name}
      label={label}
      rules={[{ required, message: 'Please select one option' }]}
    >
      <Select
        data-testid="field-airline"
        showSearch
        placeholder={placeholder ?? 'Select an airline'}
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
        }}
        onChange={onChange}
      >
        {LeashContent.airlines.map((a: Airline) => (
          <Option value={a.id} key={a.id}>
            {a.name}
          </Option>
        ))}
        <Option value="foo">Example</Option>
      </Select>
    </Form.Item>
  );
}
